module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud_m.b17f26debfd60ca13b67bced31f8ac5a.png";